/** Transport only the existing evaluator's selected rule revisions and sources. */
export function escalationMutation(result) {
  return {version: 1, steps: (result?.cascadeChain || []).map(step => ({
    ruleId: step.escalationRuleId,
    expectedRuleRevision: step.expectedRuleRevision,
    sourceIds: step.consumedDocs.map(doc => doc.id),
  }))};
}
